import type {
  FunnelConversation,
  FunnelConversationDocument,
} from 'src/api/generated';

/**
 * Makes absent optimistic fields explicit so merge-based rollback clears attempted values.
 * @param snapshot - Original relational resource or search document captured before saving.
 * @returns Original values, including undefined for omitted optimistic fields.
 */
export const getConversationRollbackSnapshot = <
  T extends FunnelConversation | FunnelConversationDocument,
>(
  snapshot: T | undefined
): T | undefined =>
  snapshot && {
    ...snapshot,
    funnelStatusId: snapshot.funnelStatusId,
    userId: snapshot.userId,
    propertyId: snapshot.propertyId,
    funnelId: snapshot.funnelId,
    archivedAt: snapshot.archivedAt,
  };
